var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 88.03 86"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#207245",
    d: "M46.04 0h5.94v8c10.01 0 20.02.02 30.03-.03 1.69.07 3.55-.05 5.02.96 1.03 1.48.91 3.36.98 5.06-.05 17.36-.03 34.71-.02 52.06-.05 2.91.27 5.88-.34 8.75-.4 2.08-2.9 2.13-4.57 2.2-10.36.03-20.73-.02-31.1 0v9h-6.21C30.53 83.23 15.26 80.67 0 78V8.01C15.35 5.34 30.7 2.71 46.04 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.98 11h33v63h-33v-6h8v-7h-8v-4h8v-7h-8v-4h8v-7h-8v-4h8v-7h-8v-4h8v-7h-8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#207245",
    d: "M63.98 17h14v7h-14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M29.62 26.37c2.26-.16 4.53-.3 6.8-.41-2.67 5.47-5.35 10.94-8.07 16.39 2.75 5.6 5.56 11.16 8.32 16.76-2.41-.14-4.81-.29-7.22-.46-1.7-4.17-3.77-8.2-4.99-12.56-1.36 4.06-3.3 7.89-4.86 11.87-2.19-.03-4.38-.12-6.57-.21 2.57-5.03 5.05-10.1 7.7-15.1-2.25-5.15-4.72-10.2-7.04-15.32 2.2-.13 4.4-.26 6.6-.38 1.49 3.91 3.12 7.77 4.35 11.78 1.32-4.25 3.29-8.25 4.98-12.36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#207245",
    d: "M63.98 28h14v7h-14zm0 11h14v7h-14zm0 11h14v7h-14zm0 11h14v7h-14z"
  })));
};
export default SvgExcel;